// Init wow.js — honor BITV/WCAG reduced-motion preference
if (
  typeof WOW !== "undefined" &&
  !(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)
) {
  new WOW().init();
}

function setAccordionPanelHeight(panel) {
  if (!panel) {
    return;
  }

  panel.style.maxHeight = panel.scrollHeight + "px";
}

function refreshOpenAccordionHeights(scope) {
  const root = scope || document;
  const openAccordions = root.querySelectorAll(".accordion.active");

  openAccordions.forEach((accordion) => {
    const panel = accordion.nextElementSibling;
    setAccordionPanelHeight(panel);
  });
}

// Auto-Preload des 360°-Panos nur auf Geräten, die dessen Dauer-Rendern
// verkraften (Analyse: docs/aktiv/360-performance-schwache-geraete.md — auf
// alten Laptops ruckelten die Startseiten-Menüs, weil das Pano im Hintergrund
// durchgehend per WebGL rendert, auf Blocklisten-GPUs sogar in Software).
// Fällt ein Kriterium durch, bleibt das Preview-JPEG stehen und die Tour lädt
// erst beim Klick — derselbe Weg, den Mobile/Tablet immer nehmen. Fehlende
// APIs zählen neutral, sonst verlöre Firefox/Safari das Pano grundlos
// (deviceMemory/connection gibt es nur in Chromium).
function deviceCanAffordPanoPreload() {
  // Nutzerwunsch schlägt Gerätefähigkeit: nichts automatisch bewegen
  // (WCAG 2.2.2), keine Megabytes im Datensparmodus.
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return false;
  }

  const connection = navigator.connection;
  if (
    connection &&
    (connection.saveData ||
      /(^|-)2g$/.test(connection.effectiveType || ""))
  ) {
    return false;
  }

  // Kerne und RAM sind je für sich schwache Proxys — nur die Kombination
  // aus beiden gilt als „zu schwach".
  const cores = navigator.hardwareConcurrency;
  const memory = navigator.deviceMemory;
  if (cores && cores <= 4 && memory && memory < 4) {
    return false;
  }

  // Software-WebGL (SwiftShader, llvmpipe, Microsoft Basic Render) macht
  // das Pano zum CPU-Dauerbrenner — der teuerste Fall, sicher ausschließen.
  try {
    const canvas = document.createElement("canvas");
    const gl =
      canvas.getContext("webgl") || canvas.getContext("experimental-webgl");

    if (!gl) {
      // Ohne WebGL fiele Marzipano auf den CSS-Renderer zurück — noch teurer.
      return false;
    }

    const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
    const renderer = debugInfo
      ? String(gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL))
      : "";
    const loseContext = gl.getExtension("WEBGL_lose_context");

    if (loseContext) {
      loseContext.loseContext();
    }

    if (/swiftshader|llvmpipe|software|basic render/i.test(renderer)) {
      return false;
    }
  } catch (error) {
    // Probe fehlgeschlagen → neutral werten, nicht ausschließen.
  }

  return true;
}

function initHero360Tour(heroSection) {
  if (!heroSection) {
    return;
  }

  heroSection.setAttribute("tabindex", "-1");

  const iframeHost = heroSection.querySelector(".iframe-360");
  const desktopOverlay = heroSection.querySelector(".activate-desktop");
  const viewIcon = heroSection.querySelector(".viewicon");
  const previewTriggers = Array.from(
    heroSection.querySelectorAll(".activate-360, .viewicon"),
  );
  const winterPreview = heroSection.querySelector('[id="360winter"]');
  const summerPreview = heroSection.querySelector('[id="360summer"]');
  const iframeSrc = winterPreview
    ? "https://360winter.weissenstadt.de"
    : summerPreview
    ? "https://360.weissenstadt.de"
    : "";

  if (!iframeHost || !iframeSrc) {
    return;
  }

  const actionButton = heroSection.querySelector("[data-ws-hero-tour-trigger]");
  const actionButtonLabel = actionButton
    ? actionButton.querySelector("[data-ws-hero-tour-label]")
    : null;
  const interactionHint = heroSection.querySelector("[data-ws-hero-tour-hint]");
  const isExperimentHero = Boolean(actionButton);
  const experimentHeader = isExperimentHero
    ? document.querySelector(
        ".ws-site-header[data-ws-site-header]",
      )
    : null;
  const brandLink = experimentHeader
    ? experimentHeader.querySelector(".ws-site-header__brand")
    : null;
  const deviceAffordsPano = deviceCanAffordPanoPreload();
  const shouldPreloadIframe =
    window.matchMedia("(min-width: 1200px)").matches && deviceAffordsPano;
  // Für postMessage zählt nur die Origin — nicht die volle URL. Explizit
  // ableiten, damit der Absender-Check auch hält, falls iframeSrc je einen
  // Pfad trägt.
  const panoOrigin = new URL(iframeSrc, window.location.href).origin;
  const rotationToggle = heroSection.querySelector(
    "[data-ws-hero-rotation-toggle]",
  );
  let iframeElement = null;
  let isActive = false;
  let interactionHintTimeout = null;
  // Steuerkanal zum Pano (Stufe 3, docs/aktiv/360-performance-schwache-geraete.md):
  // das iframe ist cross-origin, eingegriffen wird per postMessage. iframeSrc
  // ist bereits die nackte Origin und dient als targetOrigin/Absender-Check.
  let iframeReady = false;
  let pendingPanoAction = null;
  let panoRotating = false;
  let rotationPausedByUser = false;
  let heroOffscreen = false;
  let menuIsOpen = false;
  let menuHovered = false;
  let panoSuspended = false;

  function focusHeroSection() {
    if (typeof heroSection.focus !== "function") {
      return;
    }

    try {
      heroSection.focus({ preventScroll: true });
    } catch (error) {
      heroSection.focus();
    }
  }

  function restoreParentFocus() {
    if (!isActive) {
      return;
    }

    hideInteractionHint();

    window.setTimeout(() => {
      if (!isActive) {
        return;
      }

      focusHeroSection();
    }, 60);
  }

  function handleIframeFocus() {
    if (!isActive) {
      return;
    }

    hideInteractionHint();
    restoreParentFocus();
  }

  function handleWindowBlur() {
    if (!isActive || !iframeElement) {
      return;
    }

    window.setTimeout(() => {
      if (!isActive || document.activeElement !== iframeElement) {
        return;
      }

      hideInteractionHint();
      focusHeroSection();
    }, 0);
  }

  function handleEscapeKey(event) {
    if (!isActive || event.key !== "Escape") {
      return;
    }

    deactivateTour(event);
    focusHeroSection();
  }

  function setActionButtonState(active) {
    if (!actionButton) {
      return;
    }

    const defaultLabel =
      actionButton.getAttribute("data-ws-tour-label-default") || "";
    const activeLabel =
      actionButton.getAttribute("data-ws-tour-label-active") || defaultLabel;
    const defaultAria =
      actionButton.getAttribute("data-ws-tour-aria-default") || defaultLabel;
    const activeAria =
      actionButton.getAttribute("data-ws-tour-aria-active") || activeLabel;

    actionButton.classList.toggle("is-active", active);
    actionButton.setAttribute("aria-label", active ? activeAria : defaultAria);

    if (actionButtonLabel) {
      actionButtonLabel.textContent = active ? activeLabel : defaultLabel;
    }

    // Das Icon schaltet CSS anhand von .is-active um — beide Varianten stehen
    // im Markup. Frueher tauschte hier ein className-Zuweisung die FA-Klasse;
    // bei Inline-SVG geht das nicht, className ist dort schreibgeschuetzt.
  }

  function setIframeInteractivity(active) {
    if (!iframeElement) {
      return;
    }

    iframeElement.style.pointerEvents = active ? "auto" : "none";
    iframeElement.style.cursor = active ? "grab" : "";
    iframeHost.style.cursor = active ? "grab" : "";
  }

  function hideInteractionHint() {
    if (!interactionHint) {
      return;
    }

    if (interactionHintTimeout) {
      window.clearTimeout(interactionHintTimeout);
      interactionHintTimeout = null;
    }

    interactionHint.classList.remove("is-visible");
    interactionHint.setAttribute("aria-hidden", "true");
  }

  function showInteractionHint() {
    if (!interactionHint) {
      return;
    }

    interactionHint.classList.add("is-visible");
    interactionHint.setAttribute("aria-hidden", "false");

    if (interactionHintTimeout) {
      window.clearTimeout(interactionHintTimeout);
    }

    interactionHintTimeout = window.setTimeout(() => {
      interactionHint.classList.remove("is-visible");
      interactionHint.setAttribute("aria-hidden", "true");
      interactionHintTimeout = null;
    }, 5000);
  }

  function syncState() {
    heroSection.classList.toggle("is-tour-active", isActive);

    if (desktopOverlay) {
      desktopOverlay.classList.toggle("inactive", isActive);
    }

    setIframeInteractivity(isActive);
    setActionButtonState(isActive);
    syncPanoVisibility();
    syncPanoSuspension();
    updateRotationToggle();

    if (!isExperimentHero) {
      return;
    }

    document.body.classList.toggle("ws-tour-active", isActive);

    if (experimentHeader) {
      experimentHeader.classList.toggle("is-tour-active", isActive);
    }
  }

  // Ohne Preload (Mobile/Tablet, schwache Geräte) ist das Pano kein
  // Hero-Hintergrund, sondern existiert nur für die geöffnete Tour. Nach dem
  // Verlassen steht sie dort pausiert hinter dem Preview-JPEG, statt sichtbar
  // weiterzudrehen und den Pause-Knopf einzublenden.
  function panoParked() {
    return !shouldPreloadIframe && !isActive;
  }

  function syncPanoVisibility() {
    const panoVisible = Boolean(iframeElement) && !panoParked();

    heroSection.classList.toggle("is-pano-ready", iframeReady && panoVisible);

    if (viewIcon) {
      viewIcon.style.display = panoVisible ? "none" : "";
    }
  }

  function ensureIframe() {
    if (iframeElement) {
      return iframeElement;
    }

    iframeElement = document.createElement("iframe");
    iframeElement.className = "iframe-360__frame";
    iframeElement.title =
      {
        en: "360° view of Weißenstadt",
        cs: "360° pohled na Weißenstadt",
      }[document.documentElement.lang.slice(0, 2)] || "360° Weißenstadt Ansicht";
    // Das Preview-JPEG bleibt sichtbar, bis das Pano wirklich gerendert werden
    // kann — is-pano-ready blendet das iframe per CSS über das Standbild.
    iframeElement.addEventListener(
      "load",
      () => {
        iframeReady = true;
        syncPanoVisibility();

        if (pendingPanoAction) {
          const queuedAction = pendingPanoAction;
          pendingPanoAction = null;
          postToPano(queuedAction);
        }
      },
      { once: true },
    );
    // Schwaches Gerät, Tour trotzdem per Klick geöffnet: Pano ja, aber ohne
    // Autorotate — der Nutzer steuert selbst, Play in der Tour bleibt Opt-in.
    iframeElement.src = deviceAffordsPano
      ? iframeSrc
      : iframeSrc + "/?autorotate=0";
    iframeElement.width = "100%";
    iframeElement.height = "100%";
    iframeElement.tabIndex = -1;
    iframeElement.setAttribute("allowfullscreen", "true");
    iframeElement.setAttribute(
      "loading",
      shouldPreloadIframe ? "eager" : "lazy",
    );
    iframeElement.setAttribute(
      "referrerpolicy",
      "strict-origin-when-cross-origin",
    );
    iframeElement.style.display = "block";
    iframeElement.style.width = "100%";
    iframeElement.style.height = "100%";
    iframeElement.style.border = "0";
    iframeElement.style.pointerEvents = "none";

    iframeHost.appendChild(iframeElement);
    iframeHost.style.display = "block";
    iframeElement.addEventListener("focus", handleIframeFocus);
    iframeElement.addEventListener("mousedown", restoreParentFocus);
    iframeElement.addEventListener("touchstart", restoreParentFocus, {
      passive: true,
    });

    return iframeElement;
  }

  function activateTour(event) {
    if (event) {
      event.preventDefault();
    }

    ensureIframe();
    isActive = true;
    syncState();
    focusHeroSection();
    showInteractionHint();
  }

  function deactivateTour(event) {
    if (event) {
      event.preventDefault();
    }

    if (!iframeElement) {
      return;
    }

    isActive = false;
    syncState();
    hideInteractionHint();

    if (actionButton) {
      actionButton.focus();
    }
  }

  if (desktopOverlay) {
    desktopOverlay.addEventListener("click", activateTour);
  }

  previewTriggers.forEach((trigger) => {
    trigger.addEventListener("click", activateTour);
  });

  if (actionButton) {
    actionButton.addEventListener("click", (event) => {
      if (isActive) {
        deactivateTour(event);
        return;
      }

      activateTour(event);
    });
  }

  if (brandLink) {
    brandLink.addEventListener("click", (event) => {
      if (!isActive) {
        return;
      }

      deactivateTour(event);
    });
  }

  window.addEventListener("keydown", handleEscapeKey, true);
  window.addEventListener("blur", handleWindowBlur);

  if (!isExperimentHero) {
    heroSection.addEventListener("mouseleave", () => {
      if (!isActive) {
        return;
      }

      deactivateTour();
    });
  }

  function postToPano(action) {
    if (!iframeElement) {
      return;
    }

    if (!iframeReady) {
      // Nur die letzte Aktion merken — beim iframe-load zählt der Endstand.
      pendingPanoAction = action;
      return;
    }

    iframeElement.contentWindow.postMessage({ action }, panoOrigin);
  }

  function updateRotationToggle() {
    if (!rotationToggle) {
      return;
    }

    // Sichtbar nur, solange es etwas zu pausieren gibt (WCAG 2.2.2) — oder
    // der Nutzer selbst pausiert hat und wieder starten können muss. Stoppt
    // das Budget der Tour die Drehung, verschwindet der Knopf von allein
    // (Statusmeldung rotating:false; Systempausen zählen nicht, siehe
    // message-Listener). In der aktiven Tour hat der Nutzer
    // die Kontrolle ohnehin selbst (eigener Pause-Button, Draggen stoppt
    // die Drehung) — dort bleibt der Knopf weg. Ein geparktes Pano (siehe
    // panoParked) ist unsichtbar und pausiert, also auch nichts zu steuern.
    const visible =
      (panoRotating || rotationPausedByUser) && !isActive && !panoParked();
    rotationToggle.style.display = visible ? "" : "none";
    rotationToggle.classList.toggle("is-paused", rotationPausedByUser);

    const label =
      rotationToggle.getAttribute(
        rotationPausedByUser
          ? "data-ws-rotation-label-play"
          : "data-ws-rotation-label-pause",
      ) || "";
    rotationToggle.setAttribute("aria-label", label);
    rotationToggle.setAttribute("title", label);
  }

  // Pausen, die das Theme selbst verhängt — im Gegensatz zur bewussten
  // Nutzerpause über den Hero-Knopf.
  function panoBlockedBySystem() {
    return heroOffscreen || menuIsOpen || menuHovered || panoParked();
  }

  function syncPanoSuspension() {
    const shouldSuspend = panoBlockedBySystem() || rotationPausedByUser;

    if (shouldSuspend === panoSuspended) {
      return;
    }

    panoSuspended = shouldSuspend;
    postToPano(shouldSuspend ? "ws-360-pause" : "ws-360-resume");
  }

  // Statusmeldungen der Tour (dreht sie gerade?) — nur vom Pano-Origin.
  window.addEventListener("message", (event) => {
    if (event.origin !== panoOrigin) {
      return;
    }

    const data = event.data;

    if (!data || data.source !== "ws-360") {
      return;
    }

    // „Dreht nicht mehr" wegen einer Systempause (Menü/Offscreen) ist kein
    // Endzustand — sonst flackert der Pause-Knopf bei jedem Überfahren der
    // Navigation weg und wieder herein.
    if (!data.rotating && !rotationPausedByUser && panoBlockedBySystem()) {
      return;
    }

    panoRotating = Boolean(data.rotating);
    updateRotationToggle();
  });

  if (rotationToggle) {
    rotationToggle.addEventListener("click", () => {
      rotationPausedByUser = !rotationPausedByUser;

      if (rotationPausedByUser) {
        syncPanoSuspension();
      } else {
        // Bewusster Neustart: ws-360-play gibt der Tour ein frisches
        // 90-s-Budget (ein bloßes resume würde nach abgelaufenem Budget
        // stumm verpuffen und der Knopf zeigte ins Leere).
        panoSuspended = panoBlockedBySystem();
        if (!panoSuspended) {
          postToPano("ws-360-play");
        }
      }

      updateRotationToggle();
    });
  }

  // Aus dem Viewport gescrollt → Drehung anhalten: unsichtbar weiterrendern
  // ist verschenkte GPU/Akku-Zeit. Zurück im Bild → weiterlaufen lassen
  // (die Tour rechnet ihr Restbudget selbst).
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          heroOffscreen = !entry.isIntersecting;
          syncPanoSuspension();
        });
      },
      { threshold: 0.05 },
    ).observe(heroSection);
  }

  // Offenes Menü → Drehung anhalten: jeder Autorotate-Frame zwingt den
  // Browser, das Menü über dem bewegten iframe neu zu kompositen — genau
  // der auf alten Laptops gemeldete Menü-Lag. Desktop-Megamenüs tragen
  // .is-open/.is-mega-hovered im Header, das mobile Panel eine Body-Klasse.
  const siteHeaderRoot = document.querySelector(".ws-site-header");

  function menuCurrentlyOpen() {
    if (document.body.classList.contains("ws-site-header-menu-open")) {
      return true;
    }

    // Bis 1080px ist .is-open an Menüpunkten nur der Akkordeon-Zustand im
    // (meist zugeklappten) Mobil-Panel — der Header klappt den aktuellen
    // Pfad dort sogar vorab auf (site-header/view.js). Zählte das mit, galt
    // das Menü mobil dauerhaft als offen: das Pano stand schon in der
    // geöffneten Tour still, und der Pause-Knopf blieb danach hängen.
    if (window.innerWidth <= 1080) {
      return false;
    }

    return Boolean(
      siteHeaderRoot &&
        siteHeaderRoot.querySelector(".is-open, .is-mega-hovered"),
    );
  }

  if (siteHeaderRoot && "MutationObserver" in window) {
    const menuObserver = new MutationObserver(() => {
      const nextMenuOpen = menuCurrentlyOpen();

      if (nextMenuOpen !== menuIsOpen) {
        menuIsOpen = nextMenuOpen;
        syncPanoSuspension();
      }
    });

    menuObserver.observe(siteHeaderRoot, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
    menuObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  // Schon das Überfahren der Navigation hält die Drehung an, nicht erst ein
  // aufgeklapptes Megamenü: Hover-Styles, Untermenü-Transitions und der
  // Gäste/Bürger-Schalter zeichnen den Header laufend neu — auf dem gemeldeten
  // alten Laptop ruckelte genau das Wandern durch die Menüleiste. Der Hover
  // beginnt außerdem immer vor dem Aufklappen: bis das Megamenü sichtbar ist,
  // steht das Pano bereits. Nur für echte Zeiger — auf Touch gibt es kein
  // verlässliches Gegenstück zu mouseleave, das mobile Panel deckt die
  // Body-Klasse oben ab.
  const headerNav = siteHeaderRoot
    ? siteHeaderRoot.querySelector(".ws-site-header__nav")
    : null;

  if (headerNav && window.matchMedia("(hover: hover)").matches) {
    const setMenuHovered = (hovered) => {
      if (hovered === menuHovered) {
        return;
      }

      menuHovered = hovered;
      syncPanoSuspension();
      updateRotationToggle();
    };

    headerNav.addEventListener("mouseenter", () => setMenuHovered(true));
    headerNav.addEventListener("mouseleave", () => setMenuHovered(false));
  }

  if (shouldPreloadIframe) {
    // Erst nach window.load + Idle laden: Marzipano + Tiles (~1–3 MB) sollen
    // nicht mit Fonts/CSS/Bildern des kritischen Pfads um Bandbreite
    // konkurrieren. Bis dahin zeigt das Preview-JPEG den Hero.
    const schedulePreload = () => {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(() => ensureIframe(), { timeout: 3000 });
      } else {
        window.setTimeout(ensureIframe, 250);
      }
    };

    if (document.readyState === "complete") {
      schedulePreload();
    } else {
      window.addEventListener("load", schedulePreload, { once: true });
    }
  }

  syncState();
}

// TABS
document.addEventListener("DOMContentLoaded", () => {
  const tab2024Buttons = Array.from(
    document.querySelectorAll(".tab2024-button[data-tab2024]")
  );
  const tab2024Panes = Array.from(document.querySelectorAll(".tab2024-pane"));

  if (tab2024Buttons.length === 0 || tab2024Panes.length === 0) {
    return;
  }

  const tabQueryParam = "tab";
  const tabButtonsById = new Map();
  const tabButtonsByKey = new Map();

  // Tab-Semantik (WCAG 4.1.2): die Leiste war bis 31.07.2026 eine Reihe
  // gewöhnlicher Buttons. Ein Screenreader konnte weder erkennen, dass es sich
  // um Registerkarten handelt, noch welche gerade ausgewählt ist, und die
  // Panels hatten keine Verbindung zu ihrem Reiter. Die Rollen werden hier
  // gesetzt statt im Template, damit Verwaltung und Stadtrat nicht zwei
  // getrennte Quellen dafür haben.
  const tab2024List = tab2024Buttons[0].closest(".tabs2024");

  if (tab2024List) {
    tab2024List.setAttribute("role", "tablist");
  }

  tab2024Buttons.forEach((button, index) => {
    const tabId = button.getAttribute("data-tab2024");
    const tabKey = button.getAttribute("data-tab-key");

    if (tabId) {
      tabButtonsById.set(tabId, button);
    }

    if (tabKey) {
      tabButtonsByKey.set(tabKey.toLowerCase(), button);
    }

    if (!button.id) {
      button.id = `tab2024-trigger-${index + 1}`;
    }

    button.setAttribute("role", "tab");

    if (tabId) {
      button.setAttribute("aria-controls", tabId);

      const pane = document.getElementById(tabId);

      if (pane) {
        pane.setAttribute("role", "tabpanel");
        pane.setAttribute("aria-labelledby", button.id);
        // Ein Panel mit viel Text braucht einen eigenen Fokusstopp, sonst
        // können Tastaturnutzende es nicht scrollen.
        pane.setAttribute("tabindex", "0");
      }
    }
  });

  const syncTabState = (activeButton) => {
    tab2024Buttons.forEach((button) => {
      const isActive = button === activeButton;

      button.setAttribute("aria-selected", isActive ? "true" : "false");
      // Roving tabindex: der Reiterstreifen ist ein einziger Tabstopp,
      // gewechselt wird darin mit den Pfeiltasten.
      button.setAttribute("tabindex", isActive ? "0" : "-1");
    });
  };

  const activateTab = (button, shouldUpdateUrl = true) => {
    if (!button) {
      return;
    }

    const target = button.getAttribute("data-tab2024");
    if (!target) {
      return;
    }

    tab2024Buttons.forEach((btn) => btn.classList.remove("active2024"));
    button.classList.add("active2024");

    tab2024Panes.forEach((pane) => pane.classList.remove("active2024"));

    const targetPane = document.getElementById(target);
    if (targetPane) {
      targetPane.classList.add("active2024");
      window.requestAnimationFrame(() => {
        refreshOpenAccordionHeights(targetPane);
      });
    }

    syncTabState(button);

    if (!shouldUpdateUrl) {
      return;
    }

    const tabKey = button.getAttribute("data-tab-key") || target;
    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set(tabQueryParam, tabKey);
    window.history.replaceState({}, "", nextUrl.toString());
  };

  const focusTabAt = (index) => {
    const wrapped =
      (index + tab2024Buttons.length) % tab2024Buttons.length;
    const nextButton = tab2024Buttons[wrapped];

    activateTab(nextButton, true);
    nextButton.focus();
  };

  tab2024Buttons.forEach((button, index) => {
    button.addEventListener("click", () => {
      activateTab(button, true);
    });

    button.addEventListener("keydown", (event) => {
      switch (event.key) {
        case "ArrowRight":
        case "ArrowDown":
          event.preventDefault();
          focusTabAt(index + 1);
          break;
        case "ArrowLeft":
        case "ArrowUp":
          event.preventDefault();
          focusTabAt(index - 1);
          break;
        case "Home":
          event.preventDefault();
          focusTabAt(0);
          break;
        case "End":
          event.preventDefault();
          focusTabAt(tab2024Buttons.length - 1);
          break;
        default:
          break;
      }
    });
  });

  const tabFromUrl = new URLSearchParams(window.location.search).get(
    tabQueryParam
  );
  const normalizedTabFromUrl = tabFromUrl ? tabFromUrl.toLowerCase() : null;

  const tabFromParam =
    (normalizedTabFromUrl && tabButtonsByKey.get(normalizedTabFromUrl)) ||
    (tabFromUrl && tabButtonsById.get(tabFromUrl));

  const defaultTab =
    tab2024Buttons.find((button) => button.classList.contains("active2024")) ||
    tab2024Buttons[0];

  activateTab(tabFromParam || defaultTab, false);
});

jQuery(document).ready(function () {
  // Hero 360° tour (relaunch 2026): data-attribute driven, replaces the old
  // click-shield + deferred-append loader below.
  document
    .querySelectorAll("[data-ws-hero-tour-root]")
    .forEach((heroSection) => initHero360Tour(heroSection));

  // MAP CONTAINER IFRAME FRONTPAGE MAP BOTTOM

  jQuery(".map-container")
    .click(function () {
      jQuery(this).find("iframe").addClass("clicked");
    })
    .mouseleave(function () {
      jQuery(this).find("iframe").removeClass("clicked");
    });

  // jQuery(".activate-desktop").on("mouseenter", function () {
  //   jQuery(".activate-desktop").hide();
  // });

  // jQuery(".custom-header").on("mouseout", function () {
  //   jQuery(".activate-desktop").show();
  // });

  //  Replace all SVG images with inline SVG
  // https://stackoverflow.com/questions/24933430/img-src-svg-changing-the-fill-color
  // -> img -> class="svg"
  jQuery("img.svg").each(function () {
    var $img = jQuery(this);
    var imgID = $img.attr("id");
    var imgClass = $img.attr("class");
    var imgURL = $img.attr("src");
    var imgAlt = $img.attr("alt");
    var imgRole = $img.attr("role");
    var imgAriaHidden = $img.attr("aria-hidden");

    jQuery.get(
      imgURL,
      function (data) {
        // Get the SVG tag, ignore the rest
        var $svg = jQuery(data).find("svg");

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }

        // Preserve accessibility: map <img alt> to role="img" + aria-label,
        // or mark decorative when alt="" / aria-hidden was set.
        if (imgAriaHidden === "true" || imgAlt === "") {
          $svg.attr("aria-hidden", "true").attr("focusable", "false");
        } else if (typeof imgAlt !== "undefined" && imgAlt !== "") {
          $svg.attr("role", imgRole || "img").attr("aria-label", imgAlt);
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr("xmlns:a");

        // Replace image with new SVG
        $img.replaceWith($svg);
      },
      "xml"
    );
  });

  // MAP OVERLAY

  jQuery(".fp-maptext")
    .click(function () {
      jQuery(".fp-mapoverlay").fadeOut();
      jQuery(".fp-maptext").fadeOut();
      jQuery(".fp-mapiframe").show();
    })
    .mouseleave(function () {
      jQuery(".fp-mapoverlay").fadeIn();
      jQuery(".fp-maptext").fadeIn();
    });

  // Print Function
  // function printDiv(divName) {
  // 	var printContents = document.getElementById(divName).innerHTML;
  // 	var originalContents = document.body.innerHTML;
  // 	document.body.innerHTML = printContents;
  // 	window.print();
  // 	document.body.innerHTML = originalContents;
  // }
});

/*!
 * MoveTo - A lightweight scroll animation javascript library without any dependency.
 * Version 1.7.1 (22-10-2017 02:28)
 * Licensed under MIT
 * Copyright 2017 Hasan Aydoğdu <hsnaydd@gmail.com>
 */

("use strict");
var MoveTo = (function () {
  function t(t, e, n, o) {
    return (t /= o), t--, -n * (t * t * t * t - 1) + e;
  }

  function e(t, e) {
    var n = {};
    return (
      Object.keys(t).forEach(function (e) {
        n[e] = t[e];
      }),
      Object.keys(e).forEach(function (t) {
        n[t] = e[t];
      }),
      n
    );
  }

  function n(t) {
    return t.replace(/([A-Z])/g, function (t) {
      return "-" + t.toLowerCase();
    });
  }

  function o() {
    var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    (this.options = e(r, n)), (this.easeFunctions = e({ easeOutQuart: t }, o));
  }

  function i(t, e) {
    var o = {};
    return (
      Object.keys(e).forEach(function (e) {
        var i = t.getAttribute("data-mt-" + n(e));
        i && (o[e] = isNaN(i) ? i : parseInt(i, 10));
      }),
      o
    );
  }

  var r = {
    tolerance: 0,
    duration: 800,
    easing: "easeOutQuart",
    callback: function () {},
  };
  return (
    (o.prototype.registerTrigger = function (t, n) {
      var o = this;
      if (t) {
        var r = t.getAttribute("href") || t.getAttribute("data-target"),
          a =
            r && "#" !== r
              ? document.getElementById(r.substring(1))
              : document.body,
          u = e(this.options, i(t, this.options));
        "function" == typeof n && (u.callback = n);
        var c = function (t) {
          t.preventDefault(), o.move(a, u);
        };
        return (
          t.addEventListener("click", c, !1),
          function () {
            return t.removeEventListener("click", c, !1);
          }
        );
      }
    }),
    (o.prototype.move = function (t) {
      var n = this,
        o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      if (0 === t || t) {
        o = e(this.options, o);
        var i = "number" == typeof t ? t : t.getBoundingClientRect().top,
          r = window.pageYOffset,
          a = null,
          u = void 0;
        i -= o.tolerance;
        var c = function e(c) {
          var s = window.pageYOffset;
          a || (a = c - 1);
          var f = c - a;
          if (u && ((i > 0 && u > s) || (i < 0 && u < s))) return o.callback(t);
          u = s;
          var d = n.easeFunctions[o.easing](f, r, i, o.duration);
          window.scroll(0, d),
            f < o.duration
              ? window.requestAnimationFrame(e)
              : (window.scroll(0, i + r), o.callback(t));
        };
        window.requestAnimationFrame(c);
      }
    }),
    (o.prototype.addEaseFunction = function (t, e) {
      this.easeFunctions[t] = e;
    }),
    o
  );
})();
"undefined" != typeof module
  ? (module.exports = MoveTo)
  : (window.MoveTo = MoveTo);

// FIX NAVIGATION

const nav = document.querySelector(".main-navigation");
if (nav) {
  let topOfNav = nav.offsetTop;

  function fixNav() {
    if (window.scrollY >= topOfNav) {
      // document.body.style.paddingTop = nav.offsetHeight + 'px';
      document.body.classList.add("fixed-nav");
    } else {
      document.body.classList.remove("fixed-nav");
      // document.body.style.paddingTop = 0;
    }
  }

  window.addEventListener("scroll", fixNav);
}

// Slick equal height

let stHeight = jQuery(".slick-track").height();
stHeight = stHeight - 40;
jQuery(".slick-slide-buerger").css("height", stHeight + "px");

jQuery("#newsbutton").click(function () {
  jQuery("#allevents").fadeOut();
  jQuery("#allnews").fadeIn();
  jQuery("#eventbutton").removeClass("aktuellesactive");
  jQuery("#newsbutton").addClass("aktuellesactive");
});

jQuery("#eventbutton").click(function () {
  jQuery("#allnews").fadeOut();
  jQuery("#allevents").fadeIn();
  jQuery("#eventbutton").addClass("aktuellesactive");
  jQuery("#newsbutton").removeClass("aktuellesactive");
});

// Scroll-Up Function
jQuery(document).ready(function () {
  const scrollButton = jQuery("#scroll-up");

  // Initially hide the button
  scrollButton.hide();

  jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 1500) {
      scrollButton.fadeIn().css("display", "flex"); // Use flex to ensure proper display
    } else {
      scrollButton.fadeOut();
    }
  });

  // Add click handler
  scrollButton.on("click keyup", function (e) {
    // Handle both click and Enter key
    if (e.type === "click" || (e.type === "keyup" && e.key === "Enter")) {
      jQuery("html, body").animate(
        {
          scrollTop: 0,
        },
        800
      );
      return false;
    }
  });
});

// moveTo
document.addEventListener("DOMContentLoaded", function () {
  const easeFunctions = {
    easeInQuad: function (t, b, c, d) {
      t /= d;
      return c * t * t + b;
    },
    easeOutQuad: function (t, b, c, d) {
      t /= d;
      return -c * t * (t - 2) + b;
    },
  };
  const moveTo = new MoveTo(
    {
      ease: "easeInQuad",
    },
    easeFunctions
  );
  const triggers = document.getElementsByClassName("js-trigger");
  for (var i = 0; i < triggers.length; i++) {
    moveTo.registerTrigger(triggers[i]);
  }
});

// ACCORDION

// Ein geschlossenes Panel war bis 31.07.2026 nur `max-height: 0; overflow:
// hidden` — für das Auge weg, für die Tastatur nicht: Tab lief durch alle Links
// darin und der Fokus stand auf etwas Unsichtbarem (WCAG 2.4.3/2.4.7). `inert`
// nimmt Panel-Inhalt aus Fokusreihenfolge und Accessibility-Tree; die CSS-Regel
// in _posts-and-pages.scss setzt zusätzlich `visibility: hidden`, damit auch
// ohne inert-Unterstützung nichts fokussierbar bleibt.
var acc = document.getElementsByClassName("accordion");
var accordionPanelIdCounter = 0;
var i;

function setAccordionExpanded(button, panel, expanded) {
  button.setAttribute("aria-expanded", expanded ? "true" : "false");

  if (!panel) {
    return;
  }

  if (expanded) {
    panel.removeAttribute("inert");
    panel.removeAttribute("aria-hidden");
  } else {
    panel.setAttribute("inert", "");
    panel.setAttribute("aria-hidden", "true");
  }
}

function hydrateAccordionDeferredIframes(panel) {
  if (!panel) {
    return;
  }

  var iframes = panel.querySelectorAll("iframe[data-src]");

  for (var n = 0; n < iframes.length; n++) {
    var iframe = iframes[n];
    var deferredSrc = iframe.getAttribute("data-src");

    if (!deferredSrc) {
      continue;
    }

    var currentSrc = iframe.getAttribute("src");

    if (currentSrc && currentSrc !== "about:blank") {
      continue;
    }

    iframe.setAttribute("src", deferredSrc);
  }
}

function bindAccordionMediaLoad(panel) {
  if (!panel) {
    return;
  }

  var mediaElements = panel.querySelectorAll("img, iframe");

  for (var j = 0; j < mediaElements.length; j++) {
    var mediaElement = mediaElements[j];

    if (mediaElement.tagName === "IMG" && mediaElement.complete) {
      continue;
    }

    mediaElement.addEventListener(
      "load",
      function () {
        if (panel.style.maxHeight) {
          setAccordionPanelHeight(panel);
        }
      },
      { once: true }
    );
  }
}

function isAccordionPanelOpen(panel) {
  if (!panel || !panel.classList.contains("panel")) {
    return false;
  }

  var button = panel.previousElementSibling;

  return !!(button && button.classList.contains("accordion") && button.classList.contains("active"));
}

function hydrateOpenAccordionPanel(panel) {
  if (!isAccordionPanelOpen(panel)) {
    return;
  }

  hydrateAccordionDeferredIframes(panel);
  bindAccordionMediaLoad(panel);
  setAccordionPanelHeight(panel);
}

function accordionPanelFromNode(node) {
  if (!node || node.nodeType !== 1 || !node.closest) {
    return null;
  }

  return node.closest(".panel");
}

function scheduleOpenAccordionHydration(node) {
  var panel = accordionPanelFromNode(node);

  window.requestAnimationFrame(function () {
    if (panel) {
      hydrateOpenAccordionPanel(panel);
      return;
    }

    var openAccordions = document.querySelectorAll(".accordion.active");

    for (var n = 0; n < openAccordions.length; n++) {
      hydrateOpenAccordionPanel(openAccordions[n].nextElementSibling);
    }
  });
}

for (i = 0; i < acc.length; i++) {
  (function (button) {
    var panel = button.nextElementSibling;

    if (!panel || !panel.classList.contains("panel")) {
      return;
    }

    if (!panel.id) {
      accordionPanelIdCounter += 1;
      panel.id = "ws-accordion-panel-" + accordionPanelIdCounter;
    }

    button.setAttribute("aria-controls", panel.id);
    setAccordionExpanded(button, panel, button.classList.contains("active"));

    button.addEventListener("click", function () {
      this.classList.toggle("active");

      var isOpen = this.classList.contains("active");
      setAccordionExpanded(this, panel, isOpen);

      if (!isOpen) {
        panel.style.maxHeight = null;
        return;
      }

      hydrateOpenAccordionPanel(panel);
    });
  })(acc[i]);
}

// Event maps keep Google off the wire via data-src until the accordion opens.
// Borlabs then replaces that iframe with a content blocker. Clicking "Karte
// laden" injects the original markup (still data-src, no src) after hydrate
// already ran — the map stayed blank. Re-hydrate when Borlabs unblocks or
// when an iframe appears inside an open panel.
document.addEventListener("borlabs-cookie-content-unblocked[google-maps]", function (event) {
  scheduleOpenAccordionHydration(event.target);
});

document.addEventListener("borlabs-cookie-consent-saved", function () {
  window.requestAnimationFrame(function () {
    refreshOpenAccordionHeights();
    var openAccordions = document.querySelectorAll(".accordion.active");

    for (var n = 0; n < openAccordions.length; n++) {
      hydrateOpenAccordionPanel(openAccordions[n].nextElementSibling);
    }
  });
});

document.addEventListener("click", function (event) {
  var target = event.target;

  if (!target || !target.closest) {
    return;
  }

  if (!target.closest("[data-borlabs-cookie-unblock], [data-borlabs-cookie-accept-service]")) {
    return;
  }

  var panel = accordionPanelFromNode(target);

  if (!panel) {
    return;
  }

  window.setTimeout(function () {
    hydrateOpenAccordionPanel(panel);
  }, 50);
});

if (window.MutationObserver) {
  var accordionIframeObserver = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var added = mutations[m].addedNodes;

      for (var n = 0; n < added.length; n++) {
        var node = added[n];

        if (node.nodeType !== 1) {
          continue;
        }

        var hasDeferredIframe =
          (node.matches && node.matches("iframe[data-src]")) ||
          (node.querySelector && node.querySelector("iframe[data-src]"));

        if (!hasDeferredIframe) {
          continue;
        }

        scheduleOpenAccordionHydration(node);
      }
    }
  });

  accordionIframeObserver.observe(document.body, { childList: true, subtree: true });
}

window.addEventListener("resize", function () {
  window.requestAnimationFrame(function () {
    refreshOpenAccordionHeights();
  });
});

window.addEventListener("load", function () {
  refreshOpenAccordionHeights();
});

// Tagestipp

jQuery.fn.extend({
  animateCss: function (animationName, callback) {
    var animationEnd = (function (el) {
      var animations = {
        animation: "animationend",
        OAnimation: "oAnimationEnd",
        MozAnimation: "mozAnimationEnd",
        WebkitAnimation: "webkitAnimationEnd",
      };

      for (var t in animations) {
        if (el.style[t] !== undefined) {
          return animations[t];
        }
      }
    })(document.createElement("div"));

    this.addClass("animated " + animationName).one(animationEnd, function () {
      jQuery(this).removeClass("animated " + animationName);

      if (typeof callback === "function") callback();
    });

    return this;
  },
});

jQuery(document).ready(function () {
  jQuery(".rotate").on("click", function () {
    // jQuery(".rotate svg").toggleClass("down");
    jQuery(".minimenu-dropout").toggleClass("minimenu-toggled");
  });

  // jQuery('#tagestipp').addClass('animated bounceIn');

  function openTagestipp($tagestipp) {
    if (!$tagestipp.length) {
      return;
    }

    $tagestipp.find(".bummelbounce").animateCss("tada");
    $tagestipp.css({
      top: "30%",
    });
    $tagestipp.find(".tagestipp-button").attr("aria-expanded", "true");
    $tagestipp.find(".tagestipp-button").closest(".wp-block-button").hide();
    $tagestipp
      .find(".tipp-wrapperbummel")
      .removeClass("invis")
      .addClass("animated fadeIn");
  }

  function closeTagestipp($tagestipp) {
    if (!$tagestipp.length) {
      return;
    }

    $tagestipp.find(".bummelbounce").animateCss("tada");
    $tagestipp.css({
      top: "45%",
    });
    $tagestipp
      .find(".tipp-wrapperbummel")
      .addClass("invis")
      .removeClass("animated fadeIn");
    $tagestipp.find(".tagestipp-button").attr("aria-expanded", "false");
    $tagestipp.find(".tagestipp-button").closest(".wp-block-button").fadeIn();
  }

  function isTagestippOpen($tagestipp) {
    return !$tagestipp.find(".tipp-wrapperbummel").hasClass("invis");
  }

  // Ein Klick irgendwo im Trigger (Bummelkopf, Button und die Polsterung
  // ringsum) schaltet den Tipp um. Vorher traf man nur die Pille exakt und
  // knapp daneben öffnete sich die 360°-Tour aus dem Layer darunter.
  jQuery(document).on("click", "[data-ws-tagestipp-trigger]", function (event) {
    if (jQuery(event.target).closest(".tipp-closebummel").length) {
      return;
    }

    event.preventDefault();

    var $tagestipp = jQuery(this).closest("#tagestipp");

    if (isTagestippOpen($tagestipp)) {
      closeTagestipp($tagestipp);
      return;
    }

    openTagestipp($tagestipp);
  });

  // Tastatur: Enter/Space auf den Schließen-Kreisen (role="button").
  jQuery(document).on(
    "keydown",
    '#tagestipp .round-button[role="button"]',
    function (event) {
      if (
        event.key !== "Enter" &&
        event.key !== " " &&
        event.key !== "Spacebar"
      ) {
        return;
      }

      event.preventDefault();
      jQuery(this).trigger("click");
    }
  );

  jQuery(".closebummel").click(function (event) {
    event.preventDefault();

    closeTagestipp(jQuery(this).closest("#tagestipp"));
  });

  jQuery(".tipp-closebummel").click(function (event) {
    event.preventDefault();

    var $tagestipp = jQuery(this).closest("#tagestipp");

    $tagestipp.animateCss("bounceOut", function () {
      $tagestipp.addClass("invis").css({
        top: "",
      });
      $tagestipp
        .find(".tipp-wrapperbummel")
        .addClass("invis")
        .removeClass("animated fadeIn");
      $tagestipp.find(".tagestipp-button").attr("aria-expanded", "false");
      $tagestipp.find(".tagestipp-button").closest(".wp-block-button").show();
    });
  });

  jQuery("#button1").css("cursor", "pointer");
  jQuery(document).on("click", "#button1", function (event) {
    event.preventDefault();
    jQuery(".imfokuswrapper").addClass("animated bounceOut");
  });

  // IM FOKUS CLOSE
});

jQuery(document).ready(function () {
  setTimeout(function () {
    jQuery("#tagestipp").removeClass("invis");
    jQuery("#tagestipp").animateCss("bounceIn");
  }, 2500);

  setTimeout(function () {
    jQuery(".bummelbounce").animateCss("tada");
  }, 4000);
});

// SUCHE MODAL

(function () {
  var modal = document.getElementById("suchModal");
  var openBtn = document.getElementById("suchButton");
  var closeBtn = document.getElementById("suchClose");
  var backdrop = document.getElementById("suchBackdrop");

  if (!modal) return;

  // Fokusfalle: aria-modal="true" verspricht, dass der Fokus im Dialog bleibt.
  // Ohne Falle lief Tab hinter das Overlay in die weiterhin sichtbare Seite —
  // Fokus auf Elementen, die niemand sieht (WCAG 2.4.3).
  var FOCUSABLE_IN_MODAL =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex^="-"])';

  function modalFocusables() {
    return Array.prototype.filter.call(
      modal.querySelectorAll(FOCUSABLE_IN_MODAL),
      function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      }
    );
  }

  function trapFocus(event) {
    if (event.key !== "Tab" || !modal.classList.contains("is-open")) return;

    var items = modalFocusables();
    if (items.length === 0) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    } else if (!modal.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    }
  }

  function openSearch() {
    // On mobile the search button lives inside the open menu sheet — close
    // the sheet so the two overlays don't stack.
    var openHeader = document.querySelector(".ws-site-header.is-open");
    if (openHeader) {
      openHeader.classList.remove("is-open");
      var headerToggle = openHeader.querySelector(".ws-site-header__toggle");
      if (headerToggle) {
        headerToggle.setAttribute("aria-expanded", "false");
      }
    }

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    modal.removeAttribute("inert");
    if (openBtn) openBtn.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
    var field = modal.querySelector(".search-field");
    if (field) {
      // Delay focus until bar has slid into view
      setTimeout(function () { field.focus(); }, 120);
    }
  }

  function closeSearch() {
    // inert erst setzen, nachdem der Fokus den Dialog verlassen hat — sonst
    // verliert der Browser den Fokus ans <body> und die Tastaturposition ist weg.
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    if (openBtn) {
      openBtn.setAttribute("aria-expanded", "false");
      openBtn.focus();
    }
    modal.setAttribute("inert", "");
  }

  if (openBtn) {
    openBtn.addEventListener("click", openSearch);
  }

  // Additional openers, e.g. the search tile in the mobile menu's quick grid.
  document.querySelectorAll("[data-ws-open-search]").forEach(function (el) {
    el.addEventListener("click", openSearch);
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", closeSearch);
  }

  if (backdrop) {
    backdrop.addEventListener("click", closeSearch);
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.classList.contains("is-open")) {
      closeSearch();
      return;
    }

    trapFocus(e);
  });
})();

// HINTERGRUNDVIDEO PAUSIEREN (WCAG 2.2.2)
//
// Das Kultur-Modul der Startseite startet ein stummes YouTube-Video automatisch
// und in Endlosschleife. Bewegung, die länger als fünf Sekunden ohne Zutun
// läuft, braucht eine Möglichkeit zum Anhalten. Gesteuert wird über die
// postMessage-Schnittstelle des Players (`enablejsapi=1` in der iframe-URL) —
// bewusst ohne die YouTube-IFrame-API, die ein weiteres Drittanbieter-Skript
// nachladen würde.
//
// Zwei Eigenheiten der Einbindung:
//   • Vor der Cookie-Einwilligung ersetzt Borlabs das iframe durch einen
//     Content-Blocker. Der Button bleibt deshalb versteckt, bis wirklich ein
//     iframe im Container liegt — beobachtet per MutationObserver.
//   • Der Player meldet seinen Zustand zurück, sobald man sich mit
//     `{event: "listening"}` anmeldet. Damit folgt die Beschriftung dem
//     tatsächlichen Zustand und nicht nur unserer Absicht.
(function () {
  var YT_ORIGIN = "https://www.youtube-nocookie.com";

  function initBackgroundVideo(container) {
    var toggle = container.querySelector("[data-ws-bg-video-toggle]");

    if (!toggle) {
      return;
    }

    var frame = null;
    var isPlaying = true;
    // Der Player meldet seinen Zustand im Sekundentakt und mit Verzögerung.
    // Direkt nach einem Klick sind noch Meldungen des alten Zustands unterwegs —
    // ohne diese Sperrfrist drehen sie die Beschriftung wieder zurück und der
    // nächste Klick tut dann das Gegenteil von dem, was der Button ansagt.
    var ignoreStateUntil = 0;

    // targetOrigin "*" statt YT_ORIGIN: solange das iframe noch auf about:blank
    // steht (vor dem ersten load), passt seine Herkunft nicht zu YouTube und der
    // Browser verwirft die Nachricht mit einer Konsolenwarnung. Der Befehl selbst
    // enthält nichts Schützenswertes; entscheidend ist die Herkunftsprüfung in
    // der Gegenrichtung weiter unten, und die bleibt streng.
    function postToPlayer(payload) {
      if (!frame || !frame.contentWindow) {
        return;
      }

      try {
        frame.contentWindow.postMessage(JSON.stringify(payload), "*");
      } catch (error) {
        // Ein Player, der den Befehl nicht annimmt, darf die Seite nicht killen.
      }
    }

    function command(func) {
      postToPlayer({ event: "command", func: func, args: [] });
    }

    function syncLabel() {
      var label = isPlaying
        ? toggle.getAttribute("data-label-pause")
        : toggle.getAttribute("data-label-play");

      toggle.setAttribute("aria-label", label || "");
      toggle.classList.toggle("is-paused", !isPlaying);
    }

    function subscribe() {
      postToPlayer({ event: "listening", id: "ws-bg-video" });
    }

    function attachFrame(candidate) {
      if (!candidate || frame === candidate) {
        return;
      }

      frame = candidate;
      toggle.hidden = false;

      candidate.addEventListener("load", function () {
        subscribe();

        // Wer reduzierte Bewegung eingestellt hat, bekommt das Video gar nicht
        // erst laufend zu sehen — anhalten statt abspielen lassen.
        if (
          window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ) {
          isPlaying = false;
          command("pauseVideo");
          syncLabel();
        }
      });

      subscribe();
      syncLabel();
    }

    toggle.addEventListener("click", function () {
      isPlaying = !isPlaying;
      ignoreStateUntil = Date.now() + 2000;
      command(isPlaying ? "playVideo" : "pauseVideo");
      syncLabel();
    });

    window.addEventListener("message", function (event) {
      if (event.origin !== YT_ORIGIN || !frame) {
        return;
      }

      if (Date.now() < ignoreStateUntil) {
        return;
      }

      var payload;

      try {
        payload =
          typeof event.data === "string" ? JSON.parse(event.data) : event.data;
      } catch (error) {
        return;
      }

      var state = payload && payload.info && payload.info.playerState;

      // 1 = playing, 2 = paused, 3 = buffering (zählt als laufend).
      if (state === 1 || state === 3) {
        isPlaying = true;
        syncLabel();
      } else if (state === 2) {
        isPlaying = false;
        syncLabel();
      }
    });

    attachFrame(container.querySelector("[data-ws-bg-video-frame], iframe"));

    if (frame || typeof MutationObserver !== "function") {
      return;
    }

    // Borlabs hängt das iframe erst nach der Einwilligung ein.
    var observer = new MutationObserver(function () {
      var injected = container.querySelector("[data-ws-bg-video-frame], iframe");

      if (injected) {
        attachFrame(injected);
        observer.disconnect();
      }
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  document
    .querySelectorAll("[data-ws-bg-video]")
    .forEach(function (container) {
      initBackgroundVideo(container);
    });
})();
